import styled from 'styled-components';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';
import _ from 'lodash';
import { useApiInfoContextValueHook } from '../../../../../../../contexts/ApiInfoContext';
import { SellertoolSignatureUtils } from '../../../../../../../utils/sellertool-signature-utils';
import { ReturnExchangesApi } from '../../../../../../../apis/ReturnExchangesApi';
import { useFetcher } from '../../../../fetcher/useFetcher';
import { CustomBackdropController } from '../../../../../../../components/backdrop/default/v1';
import { useState } from 'react';
import { SelectStatusModal } from './select-status-modal';

const StyledTableCell = styled.td`
  padding: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;

  .returnExchangeProceedStatusButton {
    height: 30px;
    padding: 0 10px;
    border-radius: 3px;
    border: none;
    color: #fff;
    font-size: 12px;
    font-weight: 600;

    &.preparing {
      background-color: #d0d0d0; 
    }
    &.collection-request {
      background-color: #ff9f40; 
    }
    &.collecting {
      background-color: #f76707;
    }
    &.collection-complete {
      background-color: #51cf66;
    }
    &.inspection-complete {
      background-color: #1c7ed6;
    }
    &.processing-complete {
      background-color: #7048e8;
    }
    &.return-shipment {
      background-color: #fa5252;
    }
    &.exchange-re-shipment-preparation {
      background-color: #ffd43b;
    }
    &.exchange-re-shipment-complete {
      background-color: #008c8c;
    }
  }
`

export function TdReturnExchangeProceedStatus({
    returnExchange
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();

    const [selectStatusModalOpen, setSelectStatusModalOpen] = useState(false);

    const handleOpenModal = () =>{
        setSelectStatusModalOpen(true);
    }

    const handleCloseModal = () =>{
        setSelectStatusModalOpen(false);
    }

    const handleChangeStatus = async (status) => {
        const editableData = _.cloneDeep(returnExchange);

        editableData.returnExchangeProceedStatus = status;
        if (status === 'EXCHANGE_RE_SHIPMENT_COMPLETE') {
            editableData.exchangeReShipmentAt = new Date().toISOString();
        } else if (status === 'PROCESSING_COMPLETE') {
            // 처리완료일 경우 기존 데이터 이용
        } else {
            editableData.exchangeReShipmentAt = null;
        }

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }
        CustomBackdropController().showBackdrop();
        const response = await ReturnExchangesApi().updateList({
            headers: headers,
            body: {
                returnExchanges: [editableData]
            }
        });

        if (response?.content) {
            await fetcher.fetchReturnExchanges();
            setSelectStatusModalOpen(false);
        }
        CustomBackdropController().hideBackdrop();
    }
    return (
        <>
            <StyledTableCell>
                <ReturnExchangeProceedStatusButton
                    returnExchangeProceedStatus={returnExchange?.returnExchangeProceedStatus}
                    onOpenModal={handleOpenModal}
                />
            </StyledTableCell>

            {selectStatusModalOpen && (
                <SelectStatusModal
                    open={selectStatusModalOpen}
                    onClose={handleCloseModal}
                    onChangeStatus={handleChangeStatus}
                />
            )}
        </>
    );
}

function ReturnExchangeProceedStatusButton({
    returnExchangeProceedStatus,
    onOpenModal
}) {
    switch (returnExchangeProceedStatus) {
        case 'PREPARING':
            return (
                <CustomBlockButton
                    type='button'
                    className={`returnExchangeProceedStatusButton preparing`}
                    onClick={(e) => { e.stopPropagation(); onOpenModal() }}
                >
                    준비중
                </CustomBlockButton>
            );
        case 'COLLECTION_REQUEST':
            return (
                <CustomBlockButton
                    type='button'
                    className={`returnExchangeProceedStatusButton collection-request`}
                    onClick={(e) => { e.stopPropagation(); onOpenModal() }}
                >
                    수거요청
                </CustomBlockButton>
            );
        case 'COLLECTING':
            return (
                <CustomBlockButton
                    type='button'
                    className={`returnExchangeProceedStatusButton collecting`}
                    onClick={(e) => { e.stopPropagation(); onOpenModal() }}
                >
                    수거중
                </CustomBlockButton>
            );
        case 'COLLECTION_COMPLETE':
            return (
                <CustomBlockButton
                    type='button'
                    className={`returnExchangeProceedStatusButton collection-complete`}
                    onClick={(e) => { e.stopPropagation(); onOpenModal() }}
                >
                    수거완료
                </CustomBlockButton>
            );
        case 'INSPECTION_COMPLETE':
            return (
                <CustomBlockButton
                    type='button'
                    className={`returnExchangeProceedStatusButton inspection-complete`}
                    onClick={(e) => { e.stopPropagation(); onOpenModal() }}
                >
                    검수완료
                </CustomBlockButton>
            );
        case 'PROCESSING_COMPLETE':
            return (
                <CustomBlockButton
                    type='button'
                    className={`returnExchangeProceedStatusButton processing-complete`}
                    onClick={(e) => { e.stopPropagation(); onOpenModal() }}
                >
                    처리완료
                </CustomBlockButton>
            );
        case 'RETURN_SHIPMENT':
            return (
                <CustomBlockButton
                    type='button'
                    className={`returnExchangeProceedStatusButton return-shipment`}
                    onClick={(e) => { e.stopPropagation(); onOpenModal() }}
                >
                    반송
                </CustomBlockButton>
            );
        case 'EXCHANGE_RE_SHIPMENT_PREPARATION':
            return (
                <CustomBlockButton
                    type='button'
                    className={`returnExchangeProceedStatusButton exchange-re-shipment-preparation`}
                    onClick={(e) => { e.stopPropagation(); onOpenModal() }}
                >
                    교환재출고준비
                </CustomBlockButton>
            );
        case 'EXCHANGE_RE_SHIPMENT_COMPLETE':
            return (
                <CustomBlockButton
                    type='button'
                    className={`returnExchangeProceedStatusButton exchange-re-shipment-complete`}
                    onClick={(e) => { e.stopPropagation(); onOpenModal() }}
                >
                    교환재출고완료
                </CustomBlockButton>
            );
        default:
            return '';
    }
}